import { AudienceTargetingIcon } from 'foundations-assets/icons/components/AudienceTargetingIcon';
import { CapIcon } from 'foundations-assets/icons/components/CapIcon';
import { CodeIcon } from 'foundations-assets/icons/components/CodeIcon';
import { ContactsIcon } from 'foundations-assets/icons/components/ContactsIcon';
import { ContentIcon } from 'foundations-assets/icons/components/ContentIcon';
import { DealsIcon } from 'foundations-assets/icons/components/DealsIcon';
import { EmailIcon } from 'foundations-assets/icons/components/EmailIcon';
import { MarketingIcon } from 'foundations-assets/icons/components/MarketingIcon';
import { PaidAdIcon } from 'foundations-assets/icons/components/PaidAdIcon';
import { SalesIcon } from 'foundations-assets/icons/components/SalesIcon';
import { SiteTreeIcon } from 'foundations-assets/icons/components/SiteTreeIcon';
import { WebsiteIcon } from 'foundations-assets/icons/components/WebsiteIcon';

export const SERVICE_COLORS = [
  'fill-accent-purple-subtle-alt',
  'fill-accent-blue-subtle-alt',
  'fill-accent-green-subtle-alt',
  'fill-accent-yellow-subtle-alt',
] as const;

export const CAROUSEL_SERVICES_PROD = [
  {
    icon: WebsiteIcon,
    slug: 'website-development',
  },
  {
    icon: SiteTreeIcon,
    slug: 'website-design',
  },
  {
    icon: CodeIcon,
    slug: 'customer-integrations',
  },
  {
    icon: AudienceTargetingIcon,
    slug: 'account-based-marketing',
  },
  {
    icon: PaidAdIcon,
    slug: 'paid-advertising',
  },
  {
    icon: MarketingIcon,
    slug: 'full-inbound-marketing-services',
  },
  {
    icon: ContentIcon,
    slug: 'content-creation',
  },
  {
    icon: SalesIcon,
    slug: 'sales-enablement',
  },
  {
    icon: EmailIcon,
    slug: 'email-marketing',
  },
  {
    icon: CapIcon,
    slug: 'sales-coaching-and-training',
  },
  {
    icon: ContactsIcon,
    slug: 'customer-marketing',
  },
  {
    icon: DealsIcon,
    slug: 'sales-and-marketing-alignment',
  },
];

export const SUGGESTED_ACCREDITATIONS = [
  '43003', // CRM Implementation
  '52001', // HubSpot Onboarding
  '78002', // Custom Integration
  '126001', // Data Migration
  '63001', // Platform Enablement
  '126002', // Solution Architecture Design
];

export const SUGGESTED_ACCREDITATIONS_QA = [
  '1286301', // CRM Implementation
  '1286302', // Data Migration
];
